export default {
  '1': {
    caseId: '',
    no: '1-1',
    title: 'Taipei Rendezvous',
    subTitle: 'razbliuto',
    description: '記憶を無くした天才信用詐欺師ドロシーが養父の墓参りで帰省すると、養母は怪しい旅行商品に騙されそうになっていた。',
    image: '/assets/images/story-raz-1-1.jpg',
    images: [
      '/assets/images/story-raz-1-1.jpg',
      '/assets/images/story-raz-1-2.jpg',
      '/assets/images/story-raz-1-3.jpg',
      '/assets/images/story-raz-1-4.jpg',
      '/assets/images/story-raz-1-5.jpg',
      '/assets/images/story-raz-1-6.jpg',
      '/assets/images/story-raz-1-7.jpg',
      '/assets/images/story-raz-1-8.jpg',
      '/assets/images/story-raz-1-9.jpg',
      '/assets/images/story-raz-1-10.jpg'
    ],
    text:
      '<p>記憶を無くした天才信用詐欺師ドロシーが養父の墓参りで帰省すると、養母は怪しい旅行商品に騙されそうになっていた。詐欺をはたらこうとしていた男・楊を懲らしめ弱みを握ったドロシーのもとへ、友人を許してやってほしいという男・江が現れる。</p>'
  },
  '2': {
    caseId: '',
    no: '1-2',
    title: 'Taipei Rendezvous',
    subTitle: 'razbliuto',
    description: '江は台北黒社会に君臨する王の組織の若頭だった。',
    image: '/assets/images/story-raz-2-1.jpg',
    images: [
      '/assets/images/story-raz-2-1.jpg',
      '/assets/images/story-raz-2-2.jpg',
      '/assets/images/story-raz-2-3.jpg',
      '/assets/images/story-raz-2-4.jpg',
      '/assets/images/story-raz-2-5.jpg',
      '/assets/images/story-raz-2-6.jpg',
      '/assets/images/story-raz-2-7.jpg',
      '/assets/images/story-raz-2-8.jpg',
      '/assets/images/story-raz-2-9.jpg',
      '/assets/images/story-raz-2-10.jpg'
    ],
    text:
      '<p>江は台北黒社会に君臨する王の組織の若頭だった。記憶を無くし困惑している江に自分自身を重ねるドロシー。一方、王の右腕・蔡は、手下の林にドロシーを自分のもとに連れてくるように命じる。</p>'
  },
  '3': {
    caseId: '',
    no: '1-3',
    title: 'Taipei Rendezvous',
    subTitle: 'razbliuto',
    description: '組織に狙われるドロシーは、江の手引きで楊と日本へ逃亡し、京都を目指す。',
    image: '/assets/images/story-raz-3-1.jpg',
    images: [
      '/assets/images/story-raz-3-1.jpg',
      '/assets/images/story-raz-3-2.jpg',
      '/assets/images/story-raz-3-3.jpg',
      '/assets/images/story-raz-3-4.jpg',
      '/assets/images/story-raz-3-5.jpg',
      '/assets/images/story-raz-3-6.jpg',
      '/assets/images/story-raz-3-7.jpg',
      '/assets/images/story-raz-3-8.jpg',
      '/assets/images/story-raz-3-9.jpg',
      '/assets/images/story-raz-3-10.jpg'
    ],
    text:
      '<p>組織に狙われるドロシーは、江の手引きで楊と日本へ逃亡し、京都を目指す。しかし、空港で謎のバックパッカーに楊のスマホが盗まれて、後から合流するはずの江との連絡手段を絶たれてしまい…。</p>'
  },
  '4': {
    caseId: '',
    no: '1-4',
    title: 'Taipei Rendezvous',
    subTitle: 'razbliuto',
    description: 'ドロシーたちを追って日本へ向かう江の前に現れたのは、組織のボス・王だった。',
    image: '/assets/images/story-raz-4-1.jpg',
    images: [
      '/assets/images/story-raz-4-1.jpg',
      '/assets/images/story-raz-4-2.jpg',
      '/assets/images/story-raz-4-3.jpg',
      '/assets/images/story-raz-4-4.jpg',
      '/assets/images/story-raz-4-5.jpg',
      '/assets/images/story-raz-4-6.jpg',
      '/assets/images/story-raz-4-7.jpg',
      '/assets/images/story-raz-4-8.jpg',
      '/assets/images/story-raz-4-9.jpg',
      '/assets/images/story-raz-4-10.jpg'
    ],
    text:
      '<p>ドロシーたちを追って日本へ向かう江の前に現れたのは、組織のボス・王だった。そして、王がドロシーを狙う理由が明かされ、江はドロシーを連れてくるように命じられる。王への義理とドロシーへの人情、挟間で揺れ動く江が取った行動とは!?</p>'
  }
}



// WEBPACK FOOTER //
// ./src/data/razbliuto/story.js